import { render, staticRenderFns } from "./ednLoad.vue?vue&type=template&id=1283f7a7&"
import script from "./ednLoad.vue?vue&type=script&lang=js&"
export * from "./ednLoad.vue?vue&type=script&lang=js&"
import style0 from "./ednLoad.vue?vue&type=style&index=0&id=1283f7a7&prod&lang=scss&"


/* normalize component */
import normalizer from "!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports